$bog_fragile_demo_collide_child2 $bog_fragile_demo_collide_base2
	sub /
		^
		<= Attach $mol_view
			sub / <= icon \📎
